import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpensuseComponent } from './simple-icons-opensuse.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpensuseComponent ],
    exports:      [ SimpleIconsOpensuseComponent ],
    bootstrap:    []
})
export class SimpleIconsOpensuseModule {}
